/* eslint-disable max-len */
import { NATURE_OF_BIZ } from './featureTransformation';

export const fetchFeatureToolTipCaption = (feature) => {
  if (feature?.name) {
    const { name } = feature;
    const formattedFeatureName = name
      ? String(name).toUpperCase().replace(/\s+/g, '_')
      : null;

    switch (formattedFeatureName) {
      case 'LEVENSHTEIN_SCORE':
        return 'Value displayed is the measure of similarity between customer primary name and watchperson primary name.\n\nHigher the score value stronger is the match.';

      case 'LEVENSHTEIN_SORT_SCORE':
        return 'Value displayed is the measure of more in-depth similarity between customer primary name and watchperson primary name to generate a score.\n\nHigher the score stronger is the match.';

      case 'CUSTOMER_ALIAS_SCORE':
        return 'Value displayed is the measure of similarity between customer alias(es) and watchperson primary name to generate a score.\n\nHigher the score stronger is the match.';

      case 'WATCHPERSON_ALIAS_SCORE':
        return 'Value displayed is the measure of similarity between watchperson alias(es) and customer primary name to generate a score.\n\nHigher the score stronger is the match.';

      case 'SUBSET_MATCH_RATIO':
        return 'Value displayed is the measure of match between customer primary name and watchperson primary name.\n\nHigher the ratio stronger is the match.';

      case 'NUMBER_OF_MATCHING_TOKENS':
        return 'Value displayed is the count of matching words in customer primary name and watchperson primary name.\n\nHigher the number better is the match.';

      case 'NUMBER_OF_TOKEN_IN_CUSTOMER_NAME':
        return 'Value displayed is the count of words in customer primary name.';

      case 'NUMBER_OF_TOKEN_IN_WATCHPERSON_NAME':
        return 'Value displayed is the count of words in watchperson primary name.';

      case 'UNIGRAM_SCORE':
        return 'Value displayed is the measure of similarity between customer primary name and watchperson primary name to generate a score. The measure is done at 1 alphabet level.\n\nHigher the score better is the match.';

      case 'BIGRAM_SCORE':
        return 'Value displayed is the measure of similarity between customer primary name and watchperson primary name to generate a score. The measure is done at 2 alphabet level.\n\nHigher the score better is the match.';

      case 'TRIGRAM_SCORE':
        return 'Value displayed is the measure of similarity between customer primary name and watchperson primary name to generate a score. The measure is done at 3 alphabet level.\n\nHigher the score better is the match.';

      case 'AGE_DIFFERENCE':
        return 'Value displayed is the age difference between customer and watchperson age.\n\nIf one of the parameters to calculate the age difference is missing; ‘Insufficient Information’ is displayed.';

      case NATURE_OF_BIZ:
        return "Value displayed is matched predefined tokens with Customer's Nature of Business. If there is no match on the predefined tokens, ‘No Token Found’ is displayed.";
      default:
        return null;
    }
  }

  return null;
};
